import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.98828 19.9887V17.9581C6.40884 16.5709 1.55869 12.0027 1.55869 8.22917V8.00783C1.55869 4.45393 4.44305 1.5625 7.98828 1.5625C11.3193 1.5625 14.0665 4.11497 14.3864 7.37121L15.9486 8.79986C15.9666 8.60713 15.9766 8.4167 15.9766 8.22917V8.00783C15.9766 3.5923 12.393 0 7.98828 0C3.58353 0 0 3.5923 0 8.00783V8.22917C0 10.4622 1.27716 13.0646 3.79608 15.9637C5.6221 18.0652 7.42279 19.5307 7.49847 19.5921L7.98828 19.9887ZM15.1192 16.8358H12.7812V14.4922H15.1192V16.8358ZM7.98828 4.6875C9.81461 4.6875 11.3005 6.17704 11.3005 8.00784C11.3005 9.83863 9.81461 11.3282 7.98828 11.3282C6.16196 11.3282 4.67606 9.83863 4.67606 8.00784C4.67606 6.17704 6.16196 4.6875 7.98828 4.6875ZM6.23474 8.00784C6.23474 7.03852 7.02133 6.25001 7.98828 6.25001C8.95508 6.25001 9.74182 7.03852 9.74182 8.00784C9.74182 8.977 8.95508 9.76567 7.98828 9.76567C7.02133 9.76567 6.23474 8.977 6.23474 8.00784ZM18.9496 15.7741L18.5114 15.3734V17.8818C18.5114 19.0498 17.5633 20 16.3982 20H11.4633C10.2982 20 9.35013 19.0498 9.35013 17.8818V15.3734L8.9119 15.7741L7.86148 14.6199L13.9307 9.06938L20 14.6199L18.9496 15.7741ZM13.9307 11.1844L16.9527 13.9479V17.8816C16.9527 18.1882 16.7039 18.4375 16.3982 18.4375H11.4633C11.1575 18.4375 10.9088 18.1882 10.9088 17.8816V13.9479L13.9307 11.1844Z"
      />
    </Svg>
  );
};

export default Icon;
